module.exports = __webpack_public_path__ + "assets/chevron-right.0063526a.svg";